import { EntityViewPermission } from './entityViewPermission.interface';

export interface UserCommunicationDetail extends Omit<EntityViewPermission, 'subjectUUID'> {
	subjectUUID: {
		uuid: string;
		name?: string;
		type?: string;
	};
}
